import styled from 'styled-components';

export const StyledSearchBar = styled.div`
    color: white;
    width: 75%;
    height: 75%;
    display: flex;
    flex-direction: column;
    align-items: center;
`